<div id="registrierungAbschluss" class="example-container" *ngIf="form_daten && mandant">
  <app-registrierung-zusammenfassung #formular></app-registrierung-zusammenfassung>
</div>


